import { render, staticRenderFns } from "./HeadMenu.vue?vue&type=template&id=45554e47&scoped=true"
import script from "./HeadMenu.vue?vue&type=script&lang=js"
export * from "./HeadMenu.vue?vue&type=script&lang=js"
import style0 from "./HeadMenu.vue?vue&type=style&index=0&id=45554e47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45554e47",
  null
  
)

export default component.exports